export default __webpack_public_path__ + "static/media/ima400.c77cf13f.jpg";